import { ColorSwatch } from '@mantine/core';
import classes from './ColorSwatch.module.css';

export const ColorSwatchConfig = ColorSwatch.extend({
  classNames: {
    alphaOverlay: classes.alphaOverlay,
  },
});
